import axios from '@shared/api/util/axios.js'
import { createLogger } from 'vue-logger-plugin'

const loggerContext = {}
export function setLoggerContext (context) {
  Object.assign(loggerContext, context)
}
export function resetLoggerContext () {
  Object.assign(loggerContext, {
    isAuthenticated: () => false,
    getUsername: () => ''
  })
}
resetLoggerContext()

const StringifyObjectsLogHook = {
  run ({ argumentArray }) {
    for (let i = 0; i < argumentArray.length; i++) {
      if (argumentArray[i] instanceof Object) {
        if (argumentArray[i] instanceof Error) {
          // Leave Error objects intact so they're properly displayed in the console.
          // The ServerLogHook will stringify the Error before posting it to the server.
        } else {
          argumentArray[i] = JSON.stringify(argumentArray[i])
        }
      }
    }
  }
}

const ServerLogHook = {
  run ({ level, argumentArray, caller }) {
    if (!loggerContext.isAuthenticated()) {
      return
    }
    axios.post('/api/log/', {
      level: level,
      app: 'Web',
      version: import.meta.env.PACKAGE_VERSION,
      id: loggerContext.getUsername(),
      file: caller.fileName,
      line: caller.lineNumber,
      function: caller.functionName,
      message: argumentArray.map(arg => {
        // Stringify Error objects skipped in the before hook, capturing properties
        // that would otherwise be lost by a direct JSON.stringify.
        return arg instanceof Error ? JSON.stringify(arg, Object.getOwnPropertyNames(arg)) : arg
      })
    })
  }
}

const levels = ['log', 'debug', 'info', 'warn', 'error']
export const options = {
  enabled: import.meta.env.VITE_LOG_LEVEL !== undefined,
  consoleEnabled: !import.meta.env.PROD,
  callerInfo: true,
  level: levels.includes(import.meta.env.VITE_LOG_LEVEL) ? import.meta.env.VITE_LOG_LEVEL : 'error',
  beforeHooks: [
    StringifyObjectsLogHook
  ],
  afterHooks: [
    ServerLogHook
  ]
}
const logger = createLogger(options)
export default logger
